import { type WorkflowGateAuditSelectDto, WorkflowGateRuleAuditDtoStatusEnum } from '@@types/api.types';

export type MeiaPhaseReadinessStatus = {
  label: string;
  tooltip: string;
  variant: 'destructive' | 'success' | 'warning';
};

export const getMeiaPhaseReadinessStatus = (audit: WorkflowGateAuditSelectDto): MeiaPhaseReadinessStatus => {
  const failed = audit.rules.filter((rule) => rule.status === WorkflowGateRuleAuditDtoStatusEnum.Fail);
  const warningFailures = failed.filter((rule) => !rule.blocking);

  if (!audit.ready) {
    return {
      label: 'Blocked',
      tooltip: 'Required checklist items are missing. Open the checklist to see what needs work.',
      variant: 'destructive',
    };
  }

  if (warningFailures.length > 0) {
    const hasStaleScoring = warningFailures.some((rule) => rule.ruleId === 'GATE-P4-008');
    return {
      label: hasStaleScoring ? 'Stale' : 'Ready',
      tooltip: 'Required checklist items are complete, but some recommended items still need attention.',
      variant: 'warning',
    };
  }

  return {
    label: 'Ready',
    tooltip: 'All checklist items are complete.',
    variant: 'success',
  };
};
